<ng-select
  [id]="id()"
  #ngSelectComponent
  [name]="name()"
  [items]="manufacturers$ | async"
  placeholder="กรุณาเลือก"
  class="novalidate"
  [disabled]="disabled()"
  [clearable]="true"
  [compareWith]="compareWithCode"
  [editableSearchTerm]="true"
  [typeahead]="term$"
  [loading]="typeaheadLoading"
  (ngModelChange)="onValueChange($event)"
  (open)="onOpen()"
  [(ngModel)]="value"
>
  <ng-template ng-label-tmp let-item="item">
    <ng-container *ngIf="item.businessName">
      {{item.id}} : {{ item.businessName }}
    </ng-container>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <ng-container *ngIf="item.businessName">
      {{item.id}} : {{ item.businessName }}
    </ng-container>
  </ng-template>
</ng-select>
